<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="跟团名称" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="商品标题组成：商品描述+规格">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item
              label="产品亮点"
              :required="true"
            >
              <a-form-model-item
                v-for="(item,index) in ruleForm.teamStressList"
                :key="index" :rules="rules['teamStressList.value']" :prop="'teamStressList.'+index+'.value'">
                <a-input v-model="item.value" :maxLength="120" :placeholder="item.tips">
                </a-input>
              </a-form-model-item>
            </a-form-model-item>

            <a-form-model-item label="产品图片/视频" prop="imgUrls">
              <custom-upload-pro-images
                v-model="ruleForm.imgUrls"
                :pro-id="proId"
                :multiple-selected="true"
                :draggableUpdate="true"
                :enable-video="true"
                tips="建议图片长宽比为1:1，图片大小在800px*800px以上；也可上传视频"
              ></custom-upload-pro-images>
            </a-form-model-item>

            <a-form-model-item label="出发地" prop="teamDepartureList">
              <multiple-area-selected v-model="ruleForm.teamDepartureList" :only-city="false"
                                      :area-type="catalogId==73?'all':'in'"
                                      :changeOnSelect="true"></multiple-area-selected>
            </a-form-model-item>
            <a-form-model-item label="目的地" prop="teamDestinationList">
              <multiple-area-selected v-model="ruleForm.teamDestinationList" :only-city="false"
                                      :area-type="catalogId==73?'out':'in'"
                                      :changeOnSelect="true"></multiple-area-selected>
            </a-form-model-item>
            <a-form-model-item label="服务保障" prop="teamServiceGuarantee">
              <a-checkbox-group v-model="ruleForm.teamServiceGuarantee">
                <!--服务保障 1百分百出团 2无自费 3无购物 ,-->
                <a-checkbox value="1">100%出团</a-checkbox>
                <a-checkbox value="2">无购物</a-checkbox>
                <a-checkbox value="3">无自费</a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="主要景点" prop="teamMainScenic">
              <InputTags v-model="ruleForm.teamMainScenic" add-tag-name="添加景点"></InputTags>
            </a-form-model-item>
            <a-form-model-item label="图文详情" required prop="proDes">
              <CustomUeditor v-model="ruleForm.proDes"></CustomUeditor>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" v-model="ruleForm.invoiceTemplateId" :proId="proId"
                             :catalogId="catalogId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button :disabled="proSource!=0" type="primary" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <a-button v-if="proId!=0" @click="onNext()" style="margin-left: 20px">下一步</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import AreaSelected from '@/customComponents/AreaSelected/AreaSelected'
import InputTags from '@/customComponents/InputTags/InputTags'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import InvoiceSelect from '../components/InvoiceSelect'
import MultipleAreaSelected from '@/customComponents/MultipleAreaSelected/MultipleAreaSelected'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'

export default {
  name: 'TourBasicInfo',
  components: {
    ProductHeader,
    PublishHelper,
    AreaSelected,
    InputTags,
    CustomUeditor,
    InvoiceSelect,
    MultipleAreaSelected,
    CustomUploadProImages
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      ruleForm: {
        proName: '',
        teamDepartureList: [],
        teamStressList: this.getTeamStressList({})
      },
      submitLoading: false,
      submitFormData: '',
      rules: {
        proName: [
          { required: true, message: '请输入跟团标题', trigger: 'blur' }
        ],
        'teamStressList.value': [{ validator: this.validatorTeamStressListValue }],
        teamDepartureList: [
          { required: true, message: '请选择出发城市', trigger: ['blur', 'change'] }
        ],
        teamDestinationList: [
          { required: true, message: '请选择目的地', trigger: ['blur', 'change'] }
        ],
        teamServiceGuarantee: [
          { required: false, message: '请选择服务保存', trigger: ['blur', 'change'] }
        ],
        teamMainScenic: [
          { required: true, message: '请先添加景点', trigger: ['blur', 'change'] }
        ],
        proDes: [
          { required: true, message: '请输入图文详情', trigger: ['blur', 'change'] }
        ],
        invoiceTemplateId: [
          { required: true, message: '请输入选择运费模版', trigger: ['blur', 'change'] }
        ],
        imgUrls: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  mounted() {
    this.getDetails(this.proId)
  },
  methods: {
    validatorTeamStressListValue(rule, value, callback) {
      const filterList = this.ruleForm.teamStressList.filter(item => item.value)
      if (filterList && filterList.length > 0) {
        callback()
      } else {
        callback(new Error('至少要输入一个亮点'))
      }
    },
    getDetails(proId) {
      if (proId == 0) {
        return
      }
      this.getHttpServices().getProService().get('/product/team/baseInfo/query/' + proId)
        .then(details => {
          this.ruleForm = {
            imgUrls: details.imgUrls && details.imgUrls.length > 0 ? details.imgUrls.split(',') : [],
            invoiceTemplateId: details.invoiceTemplateId,
            proDes: details.proDes,
            proName: details.proName ? details.proName : '',
            teamStressList: this.getTeamStressList(details),
            teamDepartureList: details.teamDepartureList,
            teamDestinationList: details.teamDestinationList,
            teamMainScenic: details.teamMainScenic && details.teamMainScenic.length > 0 ? details.teamMainScenic.split(',') : [],
            teamServiceGuarantee: details.teamServiceGuarantee && details.teamServiceGuarantee.length > 0 ? details.teamServiceGuarantee.split(',') : []
          }
          this.$refs.InvoiceSelect.getMatchTemplateId()
          this.getLogUtils().logWithTag('getDetails', details)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSubmit() {
      console.error(this.ruleForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!', '错误')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      let submitParams = this.getSubmitParams()
      this.getHttpServices().getProService().post('/product/team/baseInfo/save', submitParams).then(proId => {
        this.getLogUtils().logWithTag('submitData', proId)
        this.ruleForm.proId = proId
        this.$message.success('产品保存成功')
        setTimeout(() => {
          this.$router.push({
            name: 'ItineraryInformation',
            query: {
              proId: this.ruleForm.proId,
              catalogId: this.catalogId,
              proSource: this.proSource,
              isBack: this.proId == 0 ? 1 : undefined
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getTeamStressList(object) {
      return [
        {
          value: object && object.teamStressOne ? object.teamStressOne : '',
          tips: '请输入亮点1'
        },
        {
          value: object && object.teamStressTwo ? object.teamStressTwo : '',
          tips: '请输入亮点2'
        },
        {
          value: object && object.teamStressThree ? object.teamStressThree : '',
          tips: '请输入亮点3'
        },
        {
          value: object && object.teamStressFour ? object.teamStressFour : '',
          tips: '请输入亮点4'
        },
        {
          value: object && object.teamStressFives ? object.teamStressFives : '',
          tips: '请输入亮点5'
        }
      ]
    },
    getSubmitParams() {
      const imgUrls = this.ruleForm.imgUrls && this.ruleForm.imgUrls.length > 0 ? this.ruleForm.imgUrls.join(',') : ''
      const teamMainScenic = this.ruleForm.teamMainScenic && this.ruleForm.teamMainScenic.length > 0 ? this.ruleForm.teamMainScenic.join(',') : ''
      const teamServiceGuarantee = this.ruleForm.teamServiceGuarantee && this.ruleForm.teamServiceGuarantee.length > 0 ? this.ruleForm.teamServiceGuarantee.join(',') : ''
      return {
        imgUrls: imgUrls,
        invoiceTemplateId: this.ruleForm.invoiceTemplateId,
        proCatalogID: this.catalogId,
        proDes: this.ruleForm.proDes,
        proId: this.proId,
        proName: this.ruleForm.proName,
        teamDepartureList: [...this.ruleForm.teamDepartureList],
        teamDestinationList: [...this.ruleForm.teamDestinationList],
        teamMainScenic: teamMainScenic,
        teamServiceGuarantee: teamServiceGuarantee,
        ...this.getTeamStress(this.ruleForm.teamStressList)
      }
    },
    getTeamStress(list) {
      if (list && list.length === 5) {
        return {
          teamStressOne: list[0].value,
          teamStressTwo: list[1].value,
          teamStressThree: list[2].value,
          teamStressFour: list[3].value,
          teamStressFives: list[4].value
        }
      }
      return {
        teamStressOne: '',
        teamStressTwo: '',
        teamStressFives: '',
        teamStressFour: '',
        teamStressThree: ''
      }
    },
    onNext() {
      this.openNewPage('ItineraryInformation', {
        proId: this.proId,
        catalogId: this.catalogId,
        proSource: this.proSource
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}
</style>